import React from 'react';
import cx from 'classnames';
import blankFlag from '../../../assets/blank.gif';
import flags from '../../../assets/flags.png';
import { FLAG, SINGLE_FLAG } from '../styles/flags';

function CountryFlag({ code }) {
  return (
    <img
      alt={code}
      className={cx(FLAG(flags), SINGLE_FLAG(code))}
      src={blankFlag} />);


}

export default CountryFlag;